import { IUser, IUserCustomProperties } from "../core/contracts/IUser";

export default class UserCustomProperty {
    static getUserCustomProperties(user: IUser | Partial<IUser> | null | undefined): IUserCustomProperties | null {
        let customProperties: IUserCustomProperties;
        if (!user || !user.custom_properties) {
            return null;
        }
        try {
            customProperties = JSON.parse(user.custom_properties);
        } catch (e) {
            return null;
        }
        return customProperties;
    }

    static getUserCustomPropertyValue(user: IUser | Partial<IUser> | null | undefined, property: keyof IUserCustomProperties) {
        const customProperties: IUserCustomProperties | null = this.getUserCustomProperties(user);
        return customProperties ? customProperties[property] : customProperties;
    }
}
